<template>
  <nav class="main_header">
    <div class="base_space">
      <div class="relative flex items-center h-12">
        <div class="flex items-center mr-2 lg:hidden">
          <button
            @click="$emit('open-sidenav')"
            class="inline-flex justify-center w-full border px-2 py-2 bg-secondary text-sm leading-5 font-medium text-primary hover:bg-white focus:outline-none focus:border-primary-light focus:ring-blue active:text-gray-800 transition ease-in-out duration-150"
            aria-label="Main menu"
            aria-expanded="false"
          >
            <BaseIcon icon="menu-toggler" class="text-xl" />
          </button>
        </div>
        <div class="flex">
          <h1 class="text-2xl">{{ title }}</h1>
        </div>
        <div class="absolute inset-y-0 right-0 flex items-center">
          <UserImpersonation v-if="$store.getters['auth/isImpersonating']" />
          <UserMainHeaderMenu />
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import UserMainHeaderMenu from './UserMainHeaderMenu.vue'
import {BaseIcon} from '@/components/base'
import UserImpersonation from './UserImpersonation.vue'

export default {
  computed: {
    title() {
      return this.$store.getters['app/pageTitle']
    },
  },
  components: {
    UserMainHeaderMenu,
    BaseIcon,
    UserImpersonation,
  },
}
</script>

<style scoped>
.main_header {
  @apply bg-white border-b mb-8 sticky top-0;

  z-index: 1990;
}
</style>
